import { render, staticRenderFns } from "./ExamAttributeTypeFormula.vue?vue&type=template&id=1ccd685a&scoped=true&"
import script from "./ExamAttributeTypeFormula.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeTypeFormula.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeTypeFormula.vue?vue&type=style&index=0&id=1ccd685a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd685a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VAlert,VChipGroup})
